<template>
    <div>
        <ContactUsTop />
        <div class="mediaAttention">
            <div class="titleStyle">
                <div class="titleFont">诚聘英才</div>
                <div class="conentFont">
                    <div class="divide"></div>
                    <span class="enFont">TALENTED PEOPLE</span>
                    <div class="divide"></div>
                </div>
            </div>
            <div class="listStyle" v-for="(item, idx) in listInfo" :key="idx">
                <div class="itemLeft">
                    <div class="leftTitle">
                        <div class="leftTitleCh">{{ item.name }}</div>
                        <div class="leftTitleEn">
                            {{ item.recruitType_dictText }}
                        </div>
                    </div>
                </div>
                <div class="line"></div>
                <div class="itemRight">
                    <div class="rightConent">
                        <div class="rightTitle">
                            [岗位职责]
                            <span
                                style="
                                    color: #d5d5d5;
                                    font-size: 16px;
                                    font-weight: normal;
                                "
                                >招聘人数：{{ item.peopleNum }}</span
                            >
                        </div>
                        <div
                            class="rightContent"
                            v-for="(iitem, i) in item.newJobRemarks"
                            :key="i"
                            v-show="i < 5"
                        >
                            {{ iitem }}
                        </div>
                        <div class="rightTitle" style="margin-top: 16px">
                            [工作地点]
                        </div>
                        <div class="rightContent">
                            {{ item.jobAddress }}
                        </div>
                    </div>
                </div>
                <div class="clickStyle">
                    <div class="clickDetail" @click="detailClick(item)">
                        查看详情
                    </div>
                </div>
            </div>
            <div class="paginationStyle">
                <a-pagination
                    :default-current="1"
                    :defaultPageSize="5"
                    :total="total"
                    :hideOnSinglePage="true"
                    @change="changePage"
                />
            </div>
        </div>
    </div>
</template>
<script>
import ContactUsTop from "@/components/ContactUsTop.vue";
import { getAction } from "@/api/services";
export default {
    name: "JoinUs",
    components: {
        ContactUsTop,
    },
    data() {
        return {
            url: "/jhwlweb/gwweb/cmsRecruit/queryPageList",
            pageNo: 1,
            pageSize: 5,
            total: undefined,
            listInfo: [],
        };
    },
    created() {
        this.getListInfo();
    },
    methods: {
        detailClick(item) {
            this.$router.push({
                name: "JoinUsDetail",
                params: item,
            });
        },
        changePage(page) {
            this.pageNo = page;
            this.getListInfo();
        },
        getListInfo() {
            let that = this;
            let parmas = {
                pageNo: that.pageNo,
                pageSize: that.pageSize,
            };
            getAction(that.url, parmas).then((res) => {
                if (res.code == 200 && res.success) {
                    that.total = res.result.total;
                    let arr = res.result.records;
                    console.info(arr)
                    arr.forEach((item) => {
                        let postRemarks = item.postRemarks.split("\n");
                        item["newPostRemarks"] = postRemarks;
                        let jobRemarks = item.jobRemarks.split("\n");
                        item["newJobRemarks"] = jobRemarks;
                    });
                    that.listInfo = arr;
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.hiddleFont {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.typeArea {
    max-width: 1100px;
    margin: 0 auto;
}
.titleStyle {
    .typeArea();
    padding-bottom: 80px;
    padding-top: 90px;
    text-align: center;
    width: 100%;
    .titleFont {
        font-family: "阿里巴巴普惠体";
        font-size: 32px;
        line-height: 28px;
        letter-spacing: 2px;
        color: #333333;
    }
    .conentFont {
        margin-top: 8px;
        .divide {
            display: inline-block;
            vertical-align: super;
            width: 20px;
            height: 2px;
            background-color: #0052d9;
        }
        .enFont {
            margin: 0 10px;
            font-family: "微软雅黑";
            font-size: 16px;
            letter-spacing: 0px;
            color: #333333;
            opacity: 0.5;
        }
    }
}
.listStyle {
    background: white;
    .typeArea();
    margin-bottom: 20px;
    display: flex;
    padding: 36px 0;
    .itemLeft {
        width: 30%;
        display: flex;
        align-items: center;
        justify-content: center;
        .leftTitle {
            font-size: 24px;
            text-align: center;
            font-family: "优设标题黑";
            font-weight: 400;
            line-height: 28px;
            .leftTitleCh {
                color: #0052d9;
            }
            .leftTitleEn {
                margin-top: 26px;
                color: #333333;
            }
        }
    }
    .line {
        height: 228px;
        border: dashed 1px #e1e1e1;
    }
    .itemRight {
        width: calc(70% - 342px);
        display: flex;
        align-items: center;
        .rightConent {
            padding-left: 55px;
            width: 100%;
            .rightTitle {
                font-size: 18px;
                font-weight: bold;
                letter-spacing: 0px;
                color: #333333;
            }
            .rightContent {
                margin-top: 16px;
                background: url("../../assets/CultivationOfTalents/smallImg.png")
                    no-repeat 0 50%;
                background-size: 14px 14px;
                .hiddleFont();
                padding-left: 25px;
                width: 100%;
                font-size: 16px;
                letter-spacing: 0px;
                color: #666666;
            }
        }
    }
    .clickStyle {
        width: 340px;
        display: flex;
        align-items: center;
        justify-content: center;
        .clickDetail {
            font-family: "优设标题黑";
            font-size: 24px;
            color: #ffffff;
            font-weight: 400;
            background: #0052d9;
            padding: 16px 46px;
            cursor: pointer;
        }
    }
}
.listStyle:hover {
    box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.2);
}
.paginationStyle {
    padding-top: 120px;
    padding-bottom: 60px;
    text-align: center;
}
.mediaAttention {
    background: #fbfbfb;
}
</style>
